import script from "./templateFormBuilder.vue?vue&type=script&setup=true&lang=js"
export * from "./templateFormBuilder.vue?vue&type=script&setup=true&lang=js"

import "./templateFormBuilder.vue?vue&type=style&index=0&id=5a424d2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a424d2e"]])

export default __exports__